const ApiPath = {
  Login: "ms-profile/user/login",
  Logout: "ms-profile/user/logout",
  Refresh: "ms-profile/user/refresh",
  GetUser: "ms-profile/user",
  GetUsers: "ms-profile/user/users",
  StationPricing: "ms-price-capture/price-capture/admin",
  PriceCapture: "ms-price-capture/",
  GenerateReport: "ms-price-capture/report",
  GenerateReportPricing: "ms-pricing/report",
  GetCompetitors: "ms-price-capture/brand",
  GetStations: "ms-price-capture/station",
  Station: "ms-station/station",
  PriceBuildUp: "ms-price-capture/price-buildup",
  Depot: "ms-price-capture/depot",
  GetStationPricing: "ms-price-capture/station/station-code/:stationCode",
  GetStationsPricing: "ms-price-capture/station",
  PriceMovement: "ms-price-capture/movement",
  ReportList: "ms-report/report",
  UpdateReport: (id) => `ms-report/report/${id}`,
};

export default ApiPath;
